import { Centrifuge } from 'centrifuge';

let cf: Centrifuge;

interface Options {
  centrifugoURL: string;
  channel: string;
  token?: string;
  projects?: unknown;
}

export const initCf = ({ centrifugoURL, channel, token = '' }: Options) => {
  cf = new Centrifuge(centrifugoURL, {
    protocol: 'json',
    data: {
      // INFO: token is used for analytics
      Authorization: token,
      channel,
      productTypes: [],
      projects: [],
    },
  });

  return cf;
};

export const getCf = () => cf;
